import { API, graphqlOperation } from 'aws-amplify';
import { GraphQLResult } from '@aws-amplify/api-graphql';

interface KPIRule {
  id: string;
  title: string;
  action: string;
  valueUnit: string;
  valueUnitPlural: string;
  actionPastTense: string;
  entitlement: string;
}

export interface ProcessedKPIRule {
  value: string;
  label: string;
  rule: KPIRule;
}

interface ListKPIRulesByOrgResponse {
  listKPIRulesByOrg: {
    items: KPIRule[];
  };
}

async function fetchKPIRules(orgID: string): Promise<ProcessedKPIRule[]> {
  const myQuery = `
    query MyQuery($orgID: ID!) {
      listKPIRulesByOrg(
        orgID: $orgID
        filter: { isDeleted: { eq: false } }
        limit: 10000
      ) {
        items {
          id
          title
          action
          valueUnit
          valueUnitPlural
          actionPastTense
          entitlement
        }
      }
    }
  `;

  try {
    const getKPIList = (await API.graphql(
      graphqlOperation(myQuery, { orgID })
    )) as GraphQLResult<ListKPIRulesByOrgResponse>;

    if (!getKPIList.data) {
      return [];
    }

    const kpiRules = getKPIList.data.listKPIRulesByOrg.items;
    const assigneeList: ProcessedKPIRule[] = [];

    for (const kpiRule of kpiRules) {
      assigneeList.push({
        value: kpiRule.id,
        label: kpiRule.title,
        rule: kpiRule,
      });
    }

    // Sort by name
    const sortedAssigneeList = assigneeList.sort((a, b) => {
      if (a.label.toLowerCase() < b.label.toLowerCase()) return -1;
      if (a.label.toLowerCase() > b.label.toLowerCase()) return 1;
      return 0;
    });

    return sortedAssigneeList;
  } catch (error) {
    console.error('Error fetching KPI rules:', error);
    return [];
  }
}

export default fetchKPIRules;
